import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpInterceptor,
  HttpSentEvent,
  HttpHeaderResponse,
  HttpProgressEvent,
  HttpResponse,
  HttpUserEvent,
} from '@angular/common/http';
import { throwError, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

import * as CryptoJS from 'crypto-js';

@Injectable()
export class ApiInterceptor implements HttpInterceptor {
  constructor() {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<
    | HttpSentEvent
    | HttpHeaderResponse
    | HttpProgressEvent
    | HttpResponse<any>
    | HttpUserEvent<any>
  > {
    request = this.attachToken(request);
    return next.handle(request);
  }

  private attachToken(request: HttpRequest<any>) {
    if (request.url.includes('/token')) {
      const token = environment.APP_TOKEN;
      let wordArrayAzp = CryptoJS.enc.Utf8.parse(
        environment.VIPPS_CLIENT_ID + ':' + environment.VIPPS_SECRET_ID
      );
      let client_authorization = CryptoJS.enc.Base64.stringify(wordArrayAzp);
      request = request.clone({
        setHeaders: {
          Authorization: `Basic ${client_authorization}`,
          apptoken: token,
        },
      });
      return request;
    } else {
      const token = environment.APP_TOKEN;
      request = request.clone({
        setHeaders: {
          apptoken: token,
        },
      });
      return request;
    }
  }
}
